import React from 'react';

function ConditionsPage({ onContinue, onShowDemand }) {
  return (
    <>
      <header className="app-header">
        <img src="/app-logo.png" alt="app logo" className="app-logo-header" />
        <h1 className="header-title">Conditions requises pour la demande d'équivalence</h1>
        <button className="btn-see-demand" onClick={onShowDemand}>
          👁️ Voir votre demande
        </button>
      </header>
      <div className="conditions-container">
        <div className="conditions-content">
          <p className="intro-text">
            Lisez attentivement les instructions suivantes avant de remplir le formulaire de demande d'équivalence :
          </p>
          <ol className="conditions-list">
            <li>Le titulaire du compte sur la présente plate-forme en est responsable.</li>
            <li>Dans un premier temps, vous remplirez le formulaire au moyen des documents, au format pdf. Il doit s'agir des <strong>copies certifiées conformes aux originaux</strong> des pièces requises, exceptée la preuve de paiement des frais de demande d'équivalence dus au MINESURSI ;</li>
            <li>Assurez-vous de ne présenter que les <strong>diplômes</strong>, et <strong>NON les attestations</strong> ;</li>
            <li>La photocopie du diplôme pour lequel l'équivalence est demandée doit être <strong>légalisée</strong> auprès de l'Ambassade de la RDC ou auprès de l'ambassade du pays de l'université ayant délivré le diplôme en RDC ;</li>
            <li>les relevés des côtes et titres académiques intermédiaires obtenus doivent être <strong>entérinés ou homologués</strong> ;</li>
            <li>Le dernier titre académique obtenu en RDC doit être <strong>authentifié</strong> ;</li>
            <li>Les diplômes d'Etat ou de baccalauréat doivent être authentifiés par le <strong>Ministère de l'EPSP</strong> ;</li>
            <li>les documents présentés dans une langue autre que le français doivent être accompagnés de leur <strong>traduction officielle en français</strong> (voir Ministère des Affaires étrangères) ;</li>
            <li>Tout dossier incomplet ou composé de pièces non conformes aux instructions ci-dessus <strong>sera rejeté</strong> ;</li>
            <li>La preuve de paiement <strong>doit impérativement</strong> porter le libellé « <strong>Paiement frais de demande d'équivalence</strong> ».</li>
          </ol>
          
          <div className="bank-accounts-section">
            <h2>Comptes bancaires du Ministère de l'Enseignement Supérieur, Universitaire, Recherche Scientifique et Innovations :</h2>
            <table className="bank-accounts-table">
              <thead>
                <tr>
                  <th>Intitulé</th>
                  <th>USD</th>
                  <th>CDF</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="account-label">Numéro Compte EQUITY-BCDC</td>
                  <td>00011050 233200174386067</td>
                  <td>00011050 233200174390820</td>
                </tr>
                <tr>
                  <td className="account-label">Numéro Compte RAWBANK</td>
                  <td>05100 05101 01001374002 82</td>
                  <td>05100 05101 01001374001 85</td>
                </tr>
                <tr>
                  <td className="account-label">Numéro Compte FIRST BANK</td>
                  <td>00014-11011-20420969394-40</td>
                  <td>00014-11011-20420969395-37</td>
                </tr>
                <tr>
                  <td className="account-label">Numéro Compte AFRILAND FIRSTBANK</td>
                  <td>00019 00001 02200640601-87</td>
                  <td>00019 00001 02200640601-92</td>
                </tr>
                <tr>
                  <td className="account-label">Numéro Compte TMB</td>
                  <td>00017-27000-73035820201-11</td>
                  <td>00017-27000-73035820300-05</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="additional-conditions">
            <ol start="11">
              <li>Les déclarations erronées, mensongères ou frauduleuses donneront lieu à des <strong>sanctions administratives</strong> et, le cas échéant, à des <strong>poursuites judiciaires</strong> ;</li>
              <li>Si après l'examen à première vue de votre dossier, celui-ci est déclaré recevable et susceptible d'obtenir une suite favorable, vous serez contacté en vue de présenter la <strong>version papier</strong> des documents requis répondant aux exigences énoncées plus haut.</li>
            </ol>
          </div>
          
          <div className="acknowledgement-section">
            <p className="acknowledgement-text">
              Je reconnais avoir pris connaissance des instructions ci-dessus et m'engage à les <strong>observer scrupuleusement</strong>.
            </p>
          </div>
          
          <div className="button-section">
            <button className="continue-button" onClick={onContinue}>CONTINUER</button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ConditionsPage;
